import React, {useState, useEffect, useRef} from 'react';
import {Flex} from '@chakra-ui/react';
import {CustomControlledInput, CustomInput} from './FormInputs';
import {getByZip} from 'zcs';

// all possible imports if we want to get fancy
// import {getByStateCity, getByCityState, getByZip, zipLookAhead, cityLookAhead, stateLookAhead} from 'zcs';

// needs register, error, and setValue props from useForm, optional required prop to know what names to register to the form.
// Use like this:
{
  /* 
<ZipCityState
      setValue={setValue}
      control={control}
      register={register}
      errors={errors}
      values={{
        zip: {id: 'smBzip', value: record.smBzip},
        city: {id: 'smBcity', value: record.smBcity},
        state: {id: 'smBstate', value: record.smBstate},
      }}
    /> 
  */
}
const ZipCityState = props => {
  const [zcs, setZcs] = useState({zip: '', city: '', state: ''});
  const [IDs, setIDs] = useState({zipId: 'zip', cityId: 'city', stateId: 'state'});

  useEffect(() => {
    if (props.values) {
      setIDs({zipId: props.values.zip.id, cityId: props.values.city.id, stateId: props.values.state.id});
      setZcs({zip: props.values.zip.value, city: props.values.city.value, state: props.values.state.value});
    }
  }, []);

  // useEffect(() => {
  //   if (IDs) setZcs({zip: IDs.zip, city: IDs.city, state: IDs.state});
  // }, [IDs]);

  const zipUpdated = e => {
    const userZip = e.target.value.toString();
    try {
      const searchVals = getByZip(userZip);
      setZcs({zip: userZip, city: searchVals.city, state: searchVals.state});

      props.setValue(props.values.city.id, searchVals.city);
      props.setValue(props.values.state.id, searchVals.state);
    } catch (err) {
      // if zip doesn't exist it would throw an error and not get to the next line, could have modified the npm module but don't want to have to check that in to sourcecontrol
      setZcs(prevZcs => {
        return {...prevZcs, zip: userZip};
      });
    }
    return userZip;
  };

  const cityUpdated = e => {
    const userCity = e.target.value;
    setZcs(prevZcs => {
      return {...prevZcs, city: userCity};
    });
    return userCity;
  };

  const stateUpdated = e => {
    const userState = e.target.value;
    setZcs(prevZcs => {
      return {...prevZcs, state: userState};
    });
    return userState;
  };
  return (
    <Flex>
      <CustomInput
        register={props.register}
        id={IDs.zipId}
        name="Zip"
        errors={props.errors}
        required={props.required}
        value={zcs.zip}
        onChange={zipUpdated}
        maxLength={10}
        isReadOnly={props.isReadOnly}
      />
      <CustomInput
        register={props.register}
        id={IDs.cityId}
        name="City"
        errors={props.errors}
        required={props.required}
        value={zcs.city}
        onChange={cityUpdated}
        isReadOnly={props.isReadOnly}
      />
      <CustomInput
        register={props.register}
        id={IDs.stateId}
        name="State"
        errors={props.errors}
        required={props.required}
        value={zcs.state}
        onChange={stateUpdated}
        maxLength={2}
        isReadOnly={props.isReadOnly}
      />
    </Flex>
  );
};

export default ZipCityState;
